export default {
    name: 'Naam',
    tel: 'telefoon',
    save: 'opslaan',
    confirm: 'bevestigen',
    cancel: 'Annuleren',
    delete: 'verwijderen',
    complete: 'Finish',
    loading: 'Bezig met laden...',
    telEmpty: 'Vul a.u.b. het telefoonnummer in',
    nameEmpty: 'vul alstublieft uw naam in',
    nameInvalid: 'Vul alstublieft een geldige naam in',
    confirmDelete: 'Weet je zeker dat je wilt verwijderen',
    telInvalid: 'Voer het juiste telefoonnummer in',
    vanCalendar: {
        end: 'einde',
        start: 'Begin',
        title: 'titel',
        confirm: 'bevestigen',
        startEnd: 'begin het einde',
        weekdays: ['Dag', 'Een', 'Twee', 'Drie', 'Vier', 'Vijf', 'Zes'],
    },
    vanCascader: {
        select: 'Gelieve te kiezen',
    },
    vanContactCard: {
        addText: 'Contacten toevoegen',
    },
    vanContactList: {
        addText: 'nieuw contact',
    },
    vanPagination: {
        prev: 'vorige pagina',
        next: 'volgende bladzijde',
    },
    vanPullRefresh: {
        pulling: 'Naar beneden trekken om te vernieuwen...',
        loosing: 'laat verversen...',
    },
    vanSubmitBar: {
        label: 'alle:',
    },
    vanCoupon: {
        unlimited: 'geen gebruiksbeperkingen',
    },
    vanCouponCell: {
        title: 'coupon',
        tips: 'Niet beschikbaar',
    },
    vanCouponList: {
        empty: 'geen coupon',
        exchange: 'aandelenbeurs',
        close: 'geen coupon',
        enable: 'bruikbaar',
        disabled: 'Niet beschikbaar',
        placeholder: 'Voer de promotiecode in',
    },
    vanAddressEdit: {
        area: 'Oppervlakte',
        postal: 'postcode',
        areaEmpty: 'regio selecteren',
        addressEmpty: 'Vul het gedetailleerde adres in',
        postalEmpty: 'Onjuist postcodeformaat',
        defaultAddress: 'Instellen als standaard verzendadres',
        telPlaceholder: 'Het mobiele telefoonnummer van de ontvanger',
        namePlaceholder: 'naam geadresseerde',
        areaPlaceholder: 'Selecteer Provincie/Stad/Regio',
    },
    vanAddressEditDetail: {
        label: 'adres',
        placeholder: 'Straatnummer, verdieping kamernummer, etc.',
    },
    vanAddressList: {
        add: 'Voeg adres toe',
    },
};
